export const BASE_PATH = "prospect.orgKYCDetails.addressInfo.addressDetails";
// export const DEFAULT_SIGNATORY_COUNTRY = "United Arab Emirates";
export const UAE = "AE";
export const OTHER_OPTION_CODE = "T6";

export const MAX_OFFICE_NUMBER_LENGTH = 50;
export const MAX_STREET_NUMBER_LENGTH = 50;
export const MAX_PO_BOX_NUMBER_LENGTH = 10;
export const MAX_OTHER_FIELD_LENGTH = 50;
export const MAX_ADDRESS_LINE1_FIELD_LENGTH = 10;
